import { Navigate, createFileRoute } from '@tanstack/react-router'

import { useViewer } from '@/identity/viewer'

export const Route = createFileRoute('/')({ component: Entrance })

/**
 * The bare address, which is nobody's destination.
 *
 * The console lives under `/admin` and the way in is `/signin`; this is the
 * address somebody types or bookmarks, and it forwards to whichever of the two
 * they can use. Kept as a forward rather than made a page, because there is no
 * third thing to say here — the admin has nothing to introduce itself with, the
 * way the product's landing page has.
 *
 * Nothing is rendered while the question is unanswered, and nothing is said
 * about a failure: an unreachable API is reported by `/signin`, which is where
 * everyone who is not an operator ends up and the one place that explains why.
 *
 * `replace`, so the back button leaves the console rather than landing here and
 * bouncing straight off again.
 */
function Entrance() {
  const who = useViewer()

  if (!who.settled) return null

  return <Navigate to={who.viewer?.administrator === true ? '/admin' : '/signin'} replace />
}
